// アプリケーション定数

export const APP_NAME = 'モニタリングツール'

// ステータスカラー
export const STATUS_COLORS = {
  operating: '#22c55e', // green-500
  idle: '#eab308', // yellow-500
  offline: '#6b7280', // gray-500
  alert: '#ef4444', // red-500
} as const

// ステータスラベル
export const STATUS_LABELS = {
  operating: '稼働中',
  idle: 'アイドル',
  offline: 'オフライン',
} as const

// アラート重要度カラー
export const SEVERITY_COLORS = {
  critical: '#ef4444', // red-500
  warning: '#f97316', // orange-500
  info: '#3b82f6', // blue-500
} as const

// アラート重要度ラベル
export const SEVERITY_LABELS = {
  critical: '重大',
  warning: '警告',
  info: '情報',
} as const

// デフォルトマップ設定
export const DEFAULT_MAP_CENTER = {
  lat: 35.6762,
  lng: 139.6503,
}
export const DEFAULT_MAP_ZOOM = 15

// ページネーション
export const DEFAULT_PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

// グラフ設定
export const CHART_COLORS = {
  operating: '#22c55e',
  idle: '#eab308',
  utilization: '#3b82f6',
}
